import { createAction } from '@reduxjs/toolkit';

import { MARK_PULSE_LOADED } from '../constants/action-types';

export const markPulseLoaded = createAction(MARK_PULSE_LOADED);
